import imageLoader from '@/utils/imageLoader';

//* vw를 쓰면 next/image가 srcset 후보를 `640 * 최소vw`로 잘라 작은 후보를 지운다 — px로만 적는다
export const GIFT_CARD_IMAGE_SIZES =
  '(max-width: 480px) 104px, (max-width: 850px) 400px, 290px';

const HERO_IMAGE_WIDTH = 828;
const HERO_IMAGE_QUALITY = 75;

export const buildGiftHeroImageUrl = (source: string) =>
  imageLoader({
    src: source,
    width: HERO_IMAGE_WIDTH,
    quality: HERO_IMAGE_QUALITY,
  });
